/**
 * Affiliate reveal — for each affiliate group on the page, show the single card
 * whose data-code matches the ?lp= query parameter and remove all others; if a
 * match is found, reveal that group's wrapper (hidden by default via CSS).
 *
 * Groups handled:
 *  - Top banner:            .affiliate-banner-card           -> .affiliate-banner-section
 *  - Product-page content:  .affiliate-product-content__card -> .affiliate-product-content
 *
 * This one script drives both the affiliate-banner section and the
 * affiliate-product-content block, so neither needs its own JS.
 */
(function () {
  const GROUPS = [
    { card: '.affiliate-banner-card', wrapper: '.affiliate-banner-section' },
    { card: '.affiliate-product-content__card', wrapper: '.affiliate-product-content' },
  ];

  function reveal(cardSelector, wrapperSelector, lpValue) {
    const cards = document.querySelectorAll(cardSelector);
    if (!cards.length) return;

    let matchFound = false;
    cards.forEach((card) => {
      if (card.dataset.code === lpValue) {
        matchFound = true;
      } else {
        card.remove();
      }
    });

    if (matchFound) {
      document.querySelectorAll(wrapperSelector).forEach((wrapper) => {
        wrapper.style.display = 'block';
      });
    }
  }

  // Send logged-out visitors back to this exact URL after login so ?lp= survives.
  function setLoginReturn() {
    const relative = window.location.pathname + window.location.search;
    document.querySelectorAll('[data-affiliate-login]').forEach((link) => {
      link.href = '/customer_authentication/login?return_to=' + encodeURIComponent(relative);
    });
  }

  function init() {
    const lpValue = new URL(window.location.href).searchParams.get('lp');
    GROUPS.forEach((group) => reveal(group.card, group.wrapper, lpValue));
    setLoginReturn();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
